import React from "react";
import { Check } from "lucide-react";

import { PROJECTS_PER_SEAT } from "../../../services/rfpBillingApi";

const COMPARE_ROWS = [
  { label: "AI Proposal Writer + Copilot", premium: true, enterprise: true },
  { label: "Smart Knowledge Base", premium: true, enterprise: true },
  { label: "Bid Intelligence", premium: true, enterprise: true },
  { label: "Team Collaboration & Reviews", premium: true, enterprise: true },
  { label: "SOC 2 aligned security", premium: true, enterprise: true },
  { label: "Single Sign-On (SSO)", premium: false, enterprise: true },
  { label: "CRM Integration", premium: false, enterprise: true },
  { label: "Projects & Exports", premium: `${PROJECTS_PER_SEAT} / seat`, enterprise: "Unlimited" },
  { label: "Support", premium: "Priority email", enterprise: "Dedicated CSM" },
  { label: "Best for", premium: "Growing teams", enterprise: "Large orgs, 11+ users" },
];

const Cell = ({ value }) =>
  value === true ? (
    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#D3F0DC] text-[#1E7A3C]">
      <Check size={14} strokeWidth={3} />
    </span>
  ) : value === false ? (
    <span className="text-[#C4C4C8]">—</span>
  ) : (
    <span className="text-[#1A1A1A]">{value}</span>
  );

// Premium vs Enterprise, shown on the trial page and on the active plan page.
export default function ComparePlansTable() {
  return (
    <div className="overflow-x-auto rounded-[14px] border border-[#ECE9EE]">
      <table className="w-full min-w-[520px] border-collapse text-[14.5px]">
        <thead>
          <tr className="bg-[#FAF9FB] text-left text-[12px] uppercase tracking-[.03em] text-[#8A8A90]">
            <th className="px-4 py-3 font-semibold" style={{ width: "40%" }}>
              Compare plans
            </th>
            <th className="border-t-2 border-[#A04A97] bg-[#FBF5FA] px-4 py-3 font-semibold text-[#893F82]">Premium</th>
            <th className="px-4 py-3 font-semibold">Enterprise</th>
          </tr>
        </thead>
        <tbody>
          {COMPARE_ROWS.map((row) => (
            <tr key={row.label} className="border-t border-[#ECE9EE]">
              <td className="px-4 py-3 text-[#1A1A1A]">{row.label}</td>
              <td className="bg-[#FBF5FA] px-4 py-3">
                <Cell value={row.premium} />
              </td>
              <td className="px-4 py-3">
                <Cell value={row.enterprise} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
